(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/tab/assets/javascripts/tab.js') >= 0) return;  svs.modules.push('/components/components/tab/assets/javascripts/tab.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components = svs.components || {};

  svs.components.Tab = function() {
    var tab = {},
      autoCollapseEventsInitiated = false,
      autoCollapseTimeOutIndex = null,
      stickItEventsInitiated = false,
      stickItOffset = 0,
      clonedTab,
      collapsedMenuContainer;

    var checkCollapsedMenuActive = function() {
      var collapsedTab = $('.js-tab-collapsed');
      if ($('.js-tab-collapsed-menu li:not(.hide).active').length > 0) {
        collapsedTab.addClass('active');
      } else {
        collapsedTab.removeClass('active');
      }
    };

    var syncActiveTab = function(tabId) {
      if (stickItEventsInitiated || autoCollapseEventsInitiated) {
        $('.js-tab, .js-tab-collapsed-menu')
          .children('li[data-tab=' + tabId + ']')
          .addClass('active');
      }
    };

    var resetActiveTab = function(currentTab) {
      var tab = currentTab.parents('.js-tab');
      tab.children().removeClass('active');

      if (tab.hasClass('tab-auto-collapse')) {
        $(
          '.js-tab.tab-auto-collapse li, .js-tab-collapsed-menu li'
        ).removeClass('active');
      }
    };

    var tabClicked = function() {
      var currentTab = $(this);

      resetActiveTab(currentTab);

      tab.show(currentTab);

      if (stickItEventsInitiated) {
        syncActiveTab(currentTab.data('tab'));
      }

      checkCollapsedMenuActive();
    };

    var initTabEvents = function() {
      $(window).on('setActiveTab', function(e, tab) {
        tabClicked.call(tab);
      });

      $(window.document).on(
        'click',
        '.js-tab li:not(.js-tab-collapsed)',
        tabClicked
      );
      $(window.document).on(
        'click',
        '.js-tab li:not(.js-tab-collapsed) a',
        function(e) {
          e.preventDefault();
        }
      );
    };

    var collapsedMenuOpen = function() {
      $('.js-tab-collapsed-menu-container').addClass('open');
    };

    var collapsedMenuClose = function(evt) {
      if ($(evt.target).hasClass('js-tab-collapsed-menu-container')) {
        $('.js-tab-collapsed-menu-container').removeClass('open');
      }
    };

    var collapsedMenuItemClick = function() {
      var currentTab = $(this);

      $(
        '.js-tab-stick-container-original .js-tab li[data-tab=' +
        currentTab.data('tab') +
        ']'
      ).click();

      $('.js-tab-collapsed-menu-container').removeClass('open');
    };

    var initAutoCollapseEvents = function() {
      $(window.document).on(
        'click',
        '.js-tab .js-tab-collapsed',
        collapsedMenuOpen
      );

      $(window.document).on(
        'click',
        '.js-tab-collapsed-menu-container',
        collapsedMenuClose
      );

      $(window.document).on(
        'click',
        '.js-tab-collapsed-menu li',
        collapsedMenuItemClick
      );

      if (svs.core.detect.formfactor.desktop()) {
        $(window).on('resize', tab.autoCollapse);
      } else {
        svs.core.detect.orientation.on('change', tab.autoCollapse);
      }
    };

    var destroyAutoCollapseEvents = function() {
      autoCollapseEventsInitiated = false;

      $(window.document).off(
        'click',
        '.js-tab .js-tab-collapsed',
        collapsedMenuOpen
      );
      $(window.document).off(
        'click',
        '.js-tab-collapsed-menu-container',
        collapsedMenuClose
      );
      $(window.document).off(
        'click',
        '.js-tab-collapsed-menu li',
        collapsedMenuItemClick
      );

      if (svs.core.detect.formfactor.desktop()) {
        $(window).off('resize', tab.autoCollapse);
      } else {
        svs.core.detect.orientation.off('change', tab.autoCollapse);
      }
    };

    var stickItResize = function() {
      stickItOffset = $('.tab-stick-em').offset().top;

      checkStickItPosition();
    };

    var checkStickItPosition = function() {
      var tabStickContainerClone = $('.js-tab-stick-container-clone'),
        checkPosition = svs.components.header.getFixedTopContentWrapperHeight();

      if (stickItOffset - $(window).scrollTop() < checkPosition) {
        tabStickContainerClone.addClass('tab-stick-container-stick-it');
      } else {
        tabStickContainerClone.removeClass('tab-stick-container-stick-it');
      }
    };

    var initStickItEvents = function() {
      stickItOffset = $('.tab-stick-em').offset().top;

      $(window).on('scroll', checkStickItPosition);

      if (svs.core.detect.formfactor.desktop()) {
        $(window).on('resize', stickItResize);
      } else {
        svs.core.detect.orientation.on('change', stickItResize);
      }
    };

    var destroyStickItEvents = function() {
      stickItEventsInitiated = false;
      $(window).off('scroll', checkStickItPosition);
      if (svs.core.detect.formfactor.desktop()) {
        $(window).off('resize', stickItResize);
      } else {
        svs.core.detect.orientation.off('change', stickItResize);
      }
    };

    var removeMarkup = function() {
      if (clonedTab) {
        clonedTab.remove();
      }
      if (collapsedMenuContainer) {
        collapsedMenuContainer.remove();
      }
    };

    tab.show = function(element, tabEl) {
      var parent =
        tabEl ||
        $(element)
          .parents('.js-tab')
          .first();
      var selected = $(parent).find('li');

      selected.removeClass('active');
      $(element).addClass('active');

      var content = $('#' + parent.attr('id') + 'Content');

      if ($(element).hasClass('tab-nested')) {
        content.find('.tab-pane-nested').removeClass('active');
      } else {
        content.find('.tab-pane:not(.tab-pane-nested)').removeClass('active');
      }

      var selector = content.find('#' + $(element).data('tab'));

      $(selector).addClass('active');

      if (stickItEventsInitiated) {
        var stickContainer = $('.tab-stick-container');

        if (stickContainer.hasClass('tab-stick-container-stick-it')) {
          $(window).scrollTop(stickContainer.offset().top - 31);
        }
      }
    };

    tab.activate = function() { };

    tab.autoCollapse = function() {
      if (autoCollapseTimeOutIndex) {
        clearTimeout(autoCollapseTimeOutIndex);
      }

      autoCollapseTimeOutIndex = setTimeout(function() {
        var tabSelector = '.js-tab:not(.js-no-auto-collapse)',
          originalTabSelector =
            '.js-tab-stick-container-original .js-tab:not(.js-no-auto-collapse)',
          collapsedMenuSelector = '.js-tab-collapsed-menu',
          tab = $(tabSelector),
          originalTab = $(originalTabSelector),
          collapsedMenu = $(collapsedMenuSelector);

        tab.addClass('tab-auto-collapse');

        if (!autoCollapseEventsInitiated) {
          if (collapsedMenu.length === 0) {
            collapsedMenuContainer = $(
              '<div class="js-tab-collapsed-menu-container tab-collapsed-menu-container"></div>'
            );
            collapsedMenuContainer.append(
              '<ul class="js-tab-collapsed-menu tab-collapsed-menu list-group list-group-default"></ul>'
            );
            $('body').append(collapsedMenuContainer);

            collapsedMenu = $(collapsedMenuSelector);

            originalTab.find('li').each(function() {
              var tabItem = $(this);

              collapsedMenu.append(
                tabItem
                  .clone()
                  .addClass(
                    'js-clickable js-clickable-delayed-click clickable-list-group-item-default list-group-item hide'
                  )
              );
            });
          }

          if (originalTab.find('.js-tab-collapsed').length === 0) {
            var collapsedItem =
              '<li class="js-tab-collapsed tab-collapsed hide"><i class="icon-default icon-nav-more icon-100"></i></li>';
            originalTab.append($(collapsedItem));
            $('.tab-stick-em-clone .js-tab').append($(collapsedItem));
          }
        }

        var totalWidth = 0,
          defaultPaddingRight = 66,
          paddingRight = 80,
          paddingLeft = 80,
          collapsedTabWidth = 50,
          contentMaxWidth = 1280,
          windowWidth = $(window).width(),
          maxWidth = windowWidth - collapsedTabWidth - defaultPaddingRight,
          tabCollapsed = $('.js-tab-collapsed');

        originalTab.find('li:not(.js-tab-collapsed)').each(function() {
          totalWidth += $(this).outerWidth();
        });

        if (windowWidth > contentMaxWidth) {
          maxWidth =
            contentMaxWidth - paddingRight - paddingLeft - collapsedTabWidth;
        } else if (windowWidth > 1024) {
          maxWidth =
            windowWidth - paddingRight - paddingLeft - collapsedTabWidth;
        } else if (windowWidth > 480) {
          maxWidth = windowWidth - paddingRight - collapsedTabWidth;
        }

        tab.find('li:not(.js-tab-collapsed)').removeClass('hide');
        collapsedMenu.find('li').addClass('hide');
        tabCollapsed.addClass('hide');

        while (totalWidth > maxWidth) {
          $(tabSelector).each(function() {
            $(this)
              .find('li:not(.hide):not(.js-tab-collapsed)')
              .last()
              .addClass('hide');
          });

          collapsedMenu
            .find('li.hide')
            .last()
            .removeClass('hide');
          tabCollapsed.removeClass('hide');

          totalWidth = 0;

          $(originalTabSelector)
            .find('li:not(.hide):not(.js-tab-collapsed)')
            .each(function() {
              totalWidth += $(this).outerWidth();
            });
        }

        checkCollapsedMenuActive();

        if (!autoCollapseEventsInitiated) {
          autoCollapseEventsInitiated = true;
          initAutoCollapseEvents();
        }
      }, 10);
    };

    tab.stickIt = function() {
      if (clonedTab) {
        clonedTab.remove();
      }

      var originalTabContainer = $('.tab-stick-container');

      clonedTab = originalTabContainer
        .clone(true, true)
        .addClass('js-tab-stick-container-clone tab-stick-container-clone');
      clonedTab.find('.tab-content').remove();
      clonedTab.find('.tab-stick-em').addClass('tab-stick-em-clone');
      clonedTab.appendTo('body');
      clonedTab.removeClass('js-tab-stick-container-original');

      originalTabContainer.addClass('js-tab-stick-container-original');

      if (!stickItEventsInitiated) {
        stickItEventsInitiated = true;
        initStickItEvents();
      }
    };

    tab.dispose = function() {
      destroyAutoCollapseEvents();
      destroyStickItEvents();
      removeMarkup();
    };

    initTabEvents();

    return tab;
  };

  svs.components.tab = new svs.components.Tab();
})(svs);

 })(window);